import React, { useState, useEffect, useRef, useCallback } from 'react';
import './BannerCarousel.css';

function BannerCarousel({ banners, autoplay, intervalSeconds }) {
  const [current, setCurrent] = useState(0);
  const pausedRef = useRef(false);
  const timerRef = useRef(null);

  const count = banners.length;

  const startTimer = useCallback(() => {
    clearInterval(timerRef.current);
    if (!autoplay || count <= 1 || pausedRef.current) return;
    timerRef.current = setInterval(() => {
      setCurrent((i) => (i + 1) % count);
    }, intervalSeconds * 1000);
  }, [autoplay, count, intervalSeconds]);

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current);
  }, [startTimer]);

  const go = (dir) => {
    pausedRef.current = true;
    clearInterval(timerRef.current);
    setCurrent((i) => (i + dir + count) % count);
  };

  const goTo = (idx) => {
    pausedRef.current = true;
    clearInterval(timerRef.current);
    setCurrent(idx);
  };

  if (!count) return null;

  return (
    <div className="banner-carousel">
      <div
        className="banner-track"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {banners.map((b) => (
          <div key={b.id} className="banner-slide">
            <img src={b.imageUrl} alt={b.title || 'Banner'} draggable={false} />
            {b.title && <div className="banner-caption">{b.title}</div>}
          </div>
        ))}
      </div>

      {count > 1 && (
        <>
          <button className="banner-nav banner-nav--prev" onClick={() => go(-1)} aria-label="Anterior">
            ‹
          </button>
          <button className="banner-nav banner-nav--next" onClick={() => go(1)} aria-label="Siguiente">
            ›
          </button>
          <div className="banner-dots">
            {banners.map((_, i) => (
              <button
                key={i}
                className={`banner-dot${i === current ? ' active' : ''}`}
                onClick={() => goTo(i)}
                aria-label={`Ir al banner ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default BannerCarousel;
